import { z } from "zod";
import { userIdSchema } from "./identity.js";
import { storedWorkSchema } from "./work-context.js";
export const onboardingProfileSchema = z.object({
    userId: userIdSchema,
    currentStep: z.string().min(1),
    isComplete: z.boolean(),
    data: z.record(z.string(), z.unknown()),
    allergens: z.array(z.string()).default([]),
    dietaryLabels: z.array(z.string()).default([]),
    /** The typed work columns. Absent on a profile built before they existed. */
    work: storedWorkSchema.optional(),
    completedAt: z.coerce.date().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const updateOnboardingSchema = z.object({
    currentStep: z.string().min(1).optional(),
    data: z.record(z.string(), z.unknown()).optional(),
    allergens: z.array(z.string()).optional(),
    dietaryLabels: z.array(z.string()).optional(),
});
//# sourceMappingURL=onboarding.js.map